export default __webpack_public_path__ + "static/media/welcome-img.3ac8bad5.jpg";